import { Button, Flex, IconPlus, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { FieldGroupBox, Tag } from 'ui'
import { messages } from './messages'
import styles from './styles'

type Props = {
  name: string
  onAdd: () => void
}

export function Empty(props: Props) {
  const { name, onAdd } = props
  const { empty } = messages

  return (
    <FieldGroupBox name={name}>
      <Flex direction="column" className={styles.content}>
        <Text variant="action2">
          <FormattedMessage
            {...empty.description}
            values={{ tag: (content) => <Tag>{content}</Tag> }}
          />
        </Text>
        <Button variant="secondary" icon={<IconPlus />} onClick={onAdd}>
          <FormattedMessage {...empty.addItems} />
        </Button>
      </Flex>
    </FieldGroupBox>
  )
}
